export const Constants = {
    // Максимальный ввод пользовательских данных
    MAX_USER_INPUTS_LENGTH: 255,
}
